/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { SalesPipelineStage } from "./SalesPipelineStage";
import {
  SalesPipelineStageFromJSON,
  SalesPipelineStageFromJSONTyped,
  SalesPipelineStageToJSON,
  SalesPipelineStageToJSONTyped,
} from "./SalesPipelineStage";
import type { CompanyNoteType } from "./CompanyNoteType";
import {
  CompanyNoteTypeFromJSON,
  CompanyNoteTypeFromJSONTyped,
  CompanyNoteTypeToJSON,
  CompanyNoteTypeToJSONTyped,
} from "./CompanyNoteType";
import type { BookingEngagement } from "./BookingEngagement";
import {
  BookingEngagementFromJSON,
  BookingEngagementFromJSONTyped,
  BookingEngagementToJSON,
  BookingEngagementToJSONTyped,
} from "./BookingEngagement";

/**
 *
 * @export
 * @interface CompanyNote
 */
export interface CompanyNote {
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  companyNoteId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyNote
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  companyId?: string;
  /**
   *
   * @type {CompanyNoteType}
   * @memberof CompanyNote
   */
  type?: CompanyNoteType;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyNote
   */
  significant?: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  salesContactId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  shipmentId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  author?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  cachedSalesContactName?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  subMessage?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  metadata?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  origin?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyNote
   */
  updatedAt?: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof CompanyNote
   */
  edited?: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  bodyHtml?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyNote
   */
  sharedRecordingLink?: string;
  /**
   *
   * @type {number}
   * @memberof CompanyNote
   */
  salesCallDurationSeconds?: number;
  /**
   *
   * @type {SalesPipelineStage}
   * @memberof CompanyNote
   */
  currentSalesPipelineStage?: SalesPipelineStage;
  /**
   *
   * @type {BookingEngagement}
   * @memberof CompanyNote
   */
  currentBookingEngagement?: BookingEngagement;
}

/**
 * Check if a given object implements the CompanyNote interface.
 */
export function instanceOfCompanyNote(value: object): value is CompanyNote {
  return true;
}

export function CompanyNoteFromJSON(json: any): CompanyNote {
  return CompanyNoteFromJSONTyped(json, false);
}

export function CompanyNoteFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyNote {
  if (json == null) {
    return json;
  }
  return {
    companyNoteId:
      json["companyNoteId"] == null ? undefined : json["companyNoteId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    type:
      json["type"] == null ? undefined : CompanyNoteTypeFromJSON(json["type"]),
    subject: json["subject"] == null ? undefined : json["subject"],
    body: json["body"] == null ? undefined : json["body"],
    significant: json["significant"] == null ? undefined : json["significant"],
    salesContactId:
      json["salesContactId"] == null ? undefined : json["salesContactId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    author: json["author"] == null ? undefined : json["author"],
    cachedSalesContactName:
      json["cachedSalesContactName"] == null
        ? undefined
        : json["cachedSalesContactName"],
    subMessage: json["subMessage"] == null ? undefined : json["subMessage"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    origin: json["origin"] == null ? undefined : json["origin"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    edited: json["edited"] == null ? undefined : json["edited"],
    updatedBy: json["updatedBy"] == null ? undefined : json["updatedBy"],
    bodyHtml: json["bodyHtml"] == null ? undefined : json["bodyHtml"],
    sharedRecordingLink:
      json["sharedRecordingLink"] == null
        ? undefined
        : json["sharedRecordingLink"],
    salesCallDurationSeconds:
      json["salesCallDurationSeconds"] == null
        ? undefined
        : json["salesCallDurationSeconds"],
    currentSalesPipelineStage:
      json["currentSalesPipelineStage"] == null
        ? undefined
        : SalesPipelineStageFromJSON(json["currentSalesPipelineStage"]),
    currentBookingEngagement:
      json["currentBookingEngagement"] == null
        ? undefined
        : BookingEngagementFromJSON(json["currentBookingEngagement"]),
  };
}

export function CompanyNoteToJSON(json: any): CompanyNote {
  return CompanyNoteToJSONTyped(json, false);
}

export function CompanyNoteToJSONTyped(
  value?: CompanyNote | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyNoteId: value["companyNoteId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    type: CompanyNoteTypeToJSON(value["type"]),
    subject: value["subject"],
    body: value["body"],
    significant: value["significant"],
    salesContactId: value["salesContactId"],
    shipmentId: value["shipmentId"],
    author: value["author"],
    cachedSalesContactName: value["cachedSalesContactName"],
    subMessage: value["subMessage"],
    metadata: value["metadata"],
    origin: value["origin"],
    updatedAt: value["updatedAt"],
    edited: value["edited"],
    updatedBy: value["updatedBy"],
    bodyHtml: value["bodyHtml"],
    sharedRecordingLink: value["sharedRecordingLink"],
    salesCallDurationSeconds: value["salesCallDurationSeconds"],
    currentSalesPipelineStage: SalesPipelineStageToJSON(
      value["currentSalesPipelineStage"],
    ),
    currentBookingEngagement: BookingEngagementToJSON(
      value["currentBookingEngagement"],
    ),
  };
}
